import React from 'react';
import { Checkbox } from '@mui/material';
import { AutocompleteMulti, AutocompleteMultiProps } from '../../Inputs';


export type AutocompleteMultiSingleGroupProps<T extends { id: string; groupId?: string }> = AutocompleteMultiProps<T> & {
  options: T[];
  getOptionLabel?: AutocompleteMultiProps<T>['getOptionLabel'];
};


export const AutocompleteMultiSingleGroup = <T extends { id: string; groupId?: string }>(props: AutocompleteMultiSingleGroupProps<T>) => {
  return (
    <AutocompleteMulti
      {...props}
      disableCloseOnSelect
      getOptionDisabled={undefined}
      processValueChange={(oldV, newV) => {
        const newItems = newV.filter(n => !oldV.includes(n));

        if (newItems) {
          const newItemsGroup = newItems?.[0]?.groupId;

          return newV.filter(v => v.groupId === newItemsGroup);
        }

        return newV;
      }}
      renderOption={(option, { selected }) => (
        <React.Fragment>
          <Checkbox style={{ marginRight: 8, padding: 2 }} checked={selected} color={props.color} /> {option.id}
        </React.Fragment>
      )}
    />
  );
};
